import { render, staticRenderFns } from "./put.vue?vue&type=template&id=12850f98&"
import script from "./put.vue?vue&type=script&lang=js&"
export * from "./put.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports